import { getAdminUsedContentRecords, getUsedContentRecords } from '../../services/EducationalProgramService'
import { getAdminUsedResourceRecords, getUsedResourceRecords } from '../../services/ResourceService'
import { isError } from '../../utils/api'

export default {
  state: {
    usedContentRecords: {
      records: null,
      totalCount: 0,
      pages: 0
    },
    usedResourceRecords: {
      records: null,
      totalCount: 0,
      pages: 0
    }
  },

  mutations: {
    hydrateUsedContentRecords(state, data) {
      if (state.usedContentRecords.records) {
        const newRecords = [...state.usedContentRecords.records, ...data.data]
        const newOrderedRecords = newRecords.sort((a, b) =>
          a.academicCourse.academicGrade.institutionalOrder - b.academicCourse.academicGrade.institutionalOrder
        )
        state.usedContentRecords.records = newOrderedRecords
      } else {
        const orderedRecords = data.data.sort((a, b) =>
          a.academicCourse.academicGrade.institutionalOrder - b.academicCourse.academicGrade.institutionalOrder
        )
        state.usedContentRecords.records = orderedRecords
      }
      state.usedContentRecords.totalCount = data.totalCount
      state.usedContentRecords.pages = data.pages
    },
    hydrateUsedResourceRecords(state, data) {
      if (state.usedResourceRecords.records) {
        const newRecords = [...state.usedResourceRecords.records, ...data.data]
        const newOrderedRecords = newRecords.sort((a, b) =>
          a.academicCourse.academicGrade.institutionalOrder - b.academicCourse.academicGrade.institutionalOrder
        )
        state.usedResourceRecords.records = newOrderedRecords
      } else {
        const orderedRecords = data.data.sort((a, b) =>
          a.academicCourse.academicGrade.institutionalOrder - b.academicCourse.academicGrade.institutionalOrder
        )
        state.usedResourceRecords.records = orderedRecords
      }
      state.usedResourceRecords.totalCount = data.totalCount
      state.usedResourceRecords.pages = data.pages
    },
    clearUsedContentRecords(state) {
      state.usedContentRecords.records = null
      state.usedContentRecords.totalCount = 0
      state.usedContentRecords.pages = 0
    },
    clearUsedResourceRecords(state) {
      state.usedResourceRecords.records = null
      state.usedResourceRecords.totalCount = 0
      state.usedResourceRecords.pages = 0
    }
  },

  actions: {
    async hydrateUsedContentRecords({ commit }, filters = {}) {
      const response = filters.isAdmin
        ? await getAdminUsedContentRecords(filters).catch(e => e.response)
        : await getUsedContentRecords(filters).catch(e => e.response)
      const success = !isError(response.status)
      if (success) commit('hydrateUsedContentRecords', response.data)
      return success
    },
    async hydrateUsedResourceRecords({ commit }, filters = {}) {
      const response = filters.isAdmin
        ? await getAdminUsedResourceRecords(filters).catch(e => e.response)
        : await getUsedResourceRecords(filters).catch(e => e.response)
      const success = !isError(response.status)
      if (success) commit('hydrateUsedResourceRecords', response.data)
      return success
    },
    clearUsedContentRecords({ commit }) {
      commit('clearUsedContentRecords')
    },
    clearUsedResourceRecords({ commit }) {
      commit('clearUsedResourceRecords')
    }
  }
}
